import React from 'react';
import {AbstractStand} from "./AbstractStand";

export const Stand6 = (props) => <AbstractStand height="20" width="30" type={"6"} {...props}/>;

